module.exports = __webpack_public_path__ + "img/active_3.6d59b925.png";